// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-enter[data-v-e22bf406],
.search-leave-to[data-v-e22bf406] {
  opacity: 0;
}
.search-enter-active[data-v-e22bf406],
.search-leave-active[data-v-e22bf406] {
  transition: all 0.2s linear;
}
.list-enter[data-v-e22bf406],
.list-leave-to[data-v-e22bf406] {
  opacity: 0;
}
.list-enter-active[data-v-e22bf406],
.list-leave-active[data-v-e22bf406] {
  transition: all 0.2s;
}
.search-contacts[data-v-e22bf406] {
  position: relative;
  width: 100%;
  background-color: var(--bg-color);
  overflow-y: auto;
  max-height: 284px;
  height: 71px;
  border-top: 1px solid #D3D3D3;
}
.search-contacts .search-contacts-info[data-v-e22bf406] {
  height: 100%;
  display: flex;
  align-items: center;
  padding-left: 17px;
}
.search-contacts .search-contacts-list[data-v-e22bf406] {
  height: 100%;
}
.search-contacts .search-contacts-list .fade-list[data-v-e22bf406] {
  overflow: hidden;
}
.search-contacts .search-contacts-list .fade-list .contact[data-v-e22bf406] {
  padding: 7px 17px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
}
.search-contacts .search-contacts-list .fade-list .contact[data-v-e22bf406]:hover {
  background-color: #F7F7F7;
}
.search-contacts .search-contacts-list .fade-list .contact .fio[data-v-e22bf406] {
  margin-left: 10px;
}
.search-contacts-none[data-v-e22bf406] {
  border-top: none;
  height: 0 !important;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/SearchContacts.vue"],"names":[],"mappings":"AAAA;;EAEE,UAAU;AACZ;AACA;;EAEE,2BAA2B;AAC7B;AACA;;EAEE,UAAU;AACZ;AACA;;EAEE,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,iCAAiC;EACjC,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,oBAAoB;AACtB","sourcesContent":[".search-enter[data-v-e22bf406],\n.search-leave-to[data-v-e22bf406] {\n  opacity: 0;\n}\n.search-enter-active[data-v-e22bf406],\n.search-leave-active[data-v-e22bf406] {\n  transition: all 0.2s linear;\n}\n.list-enter[data-v-e22bf406],\n.list-leave-to[data-v-e22bf406] {\n  opacity: 0;\n}\n.list-enter-active[data-v-e22bf406],\n.list-leave-active[data-v-e22bf406] {\n  transition: all 0.2s;\n}\n.search-contacts[data-v-e22bf406] {\n  position: relative;\n  width: 100%;\n  background-color: var(--bg-color);\n  overflow-y: auto;\n  max-height: 284px;\n  height: 71px;\n  border-top: 1px solid #D3D3D3;\n}\n.search-contacts .search-contacts-info[data-v-e22bf406] {\n  height: 100%;\n  display: flex;\n  align-items: center;\n  padding-left: 17px;\n}\n.search-contacts .search-contacts-list[data-v-e22bf406] {\n  height: 100%;\n}\n.search-contacts .search-contacts-list .fade-list[data-v-e22bf406] {\n  overflow: hidden;\n}\n.search-contacts .search-contacts-list .fade-list .contact[data-v-e22bf406] {\n  padding: 7px 17px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  cursor: pointer;\n}\n.search-contacts .search-contacts-list .fade-list .contact[data-v-e22bf406]:hover {\n  background-color: #F7F7F7;\n}\n.search-contacts .search-contacts-list .fade-list .contact .fio[data-v-e22bf406] {\n  margin-left: 10px;\n}\n.search-contacts-none[data-v-e22bf406] {\n  border-top: none;\n  height: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
